// eslint-disable-next-line import/prefer-default-export
export const dismissedWizardKey = 'ENTANDO_WELCOME_WIZARD_DISMISSED';
